import { request } from '@/shared/api/request'

export const approveTradeUnion = (params) => {
	return request({ url: `colcontract/tradeUnion/approveTradeUnion/${params}`, method: 'POST' })
}